module.exports = __webpack_public_path__ + "static/media/logo.61e24509.png";